import { render, staticRenderFns } from "./lazy-video-iframe.vue?vue&type=template&id=ad7aabda"
import script from "./lazy-video-iframe.vue?vue&type=script&lang=js"
export * from "./lazy-video-iframe.vue?vue&type=script&lang=js"
import style0 from "./lazy-video-iframe.vue?vue&type=style&index=0&id=ad7aabda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports